import {
  getPlans,
  getTierPlans,
  getSelectedTierPlan,
  getAllTierPlans,
  getSelectedPlan,
  getCurrentSubscription,
  getCurrentTierPlan,
  isCryptoPaymentEnabled,
  hasRecurringPayment,
  isUpgradingCurrentPlan,
} from '@/composables/paymentPlanMethods'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export const usePaymentPlan = () => {
  const route = useRoute()
  const store = useStore()

  const gm_type = computed(() => route.query.gm_type as string)
  const gm_tier = computed(() => route.query.gm_tier as string)
  const gm_interval = computed(() => route.query.gm_interval as string)

  const selectedTierPlans = computed(() =>
    getTierPlans({ type: gm_type.value, tier: gm_tier.value }),
  )

  const selectedTierPlan = computed(() =>
    getSelectedTierPlan({
      type: gm_type.value,
      tier: gm_tier.value,
      interval: gm_interval.value,
      selectedTierPlans: selectedTierPlans.value,
    }),
  )

  const currentSubscription = computed(() => getCurrentSubscription(gm_type.value))

  const allTierPlans = computed(() => getAllTierPlans(gm_type.value))

  const selectedPlan = computed(() =>
    getSelectedPlan({
      type: gm_type.value,
      tier: gm_tier.value,
      interval: gm_interval.value,
      plans: getPlans(),
    }),
  )

  const currentPlan = computed(() => currentSubscription.value?.plan)

  const currentTierPlan = computed(() => {
    if (!currentSubscription.value) return null
    return getCurrentTierPlan(currentSubscription.value.plan, allTierPlans.value)
  })

  const plans = computed(() => getPlans())

  const alipayEnabled = computed(() => store.getters.user_has_flag('ALIPAY'))

  const wechatPayEnabled = computed(() => store.getters.user_has_flag('WECHAT_PAY'))

  const cryptoEnabled = computed(() => store.getters.user_has_flag('CONFIRMO'))

  const cryptoPaymentEnabled = computed(
    () => currentPlan.value && isCryptoPaymentEnabled(currentPlan.value),
  )

  const cryptoSubscriptionActive = computed(
    () => currentPlan.value && currentPlan.value.provider === 'Confirmo',
  )

  const upgradingCurrentPlan = computed(
    () => currentPlan.value && isUpgradingCurrentPlan(currentPlan.value),
  )

  const paypalPaymentEnabled = computed(() => store.getters.user_has_flag('GATESBTNS'))

  const adyenPaymentEnabled = computed(() => store.getters.user_has_flag('ADYEN'))

  const isCurrentPlanRecurring = computed(
    () => currentPlan.value && hasRecurringPayment(currentPlan.value),
  )

  const allowedPaymentMethods = computed(() => {
    const result = ['card']

    if (cryptoPaymentEnabled.value) {
      result.push('crypto')
    }
    if (alipayEnabled.value || wechatPayEnabled.value) {
      result.push('other')
    }
    if (paypalPaymentEnabled.value) {
      result.push('paypal')
    }

    return result
  })

  const multiplePaymentMethods = computed(() => allowedPaymentMethods.value.length > 1)

  return {
    allowedPaymentMethods,
    allTierPlans,
    currentSubscription,
    currentTierPlan,
    currentPlan,
    gm_type,
    gm_tier,
    gm_interval,
    plans,
    selectedTierPlans,
    selectedTierPlan,
    selectedPlan,
    cryptoEnabled,
    alipayEnabled,
    wechatPayEnabled,
    cryptoPaymentEnabled,
    cryptoSubscriptionActive,
    upgradingCurrentPlan,
    paypalPaymentEnabled,
    adyenPaymentEnabled,
    multiplePaymentMethods,
    isCurrentPlanRecurring,
  }
}
